import qualityWarningSlice, { close } from './qualityWarningSlice'
  

  export const qualityWarningReducer = qualityWarningSlice.reducer
  export const qualityWarningActions = {...qualityWarningSlice.actions,
    close:  close
}
  